import React, { useState, useRef } from 'react';
import { Carousel, Tabs, Typography, Modal } from 'antd';
import { STATIC_RESOURCE } from '../../../../origin';
import { chunk } from '../../util';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import { imgs_list, tabs_list, classify_list } from '../../const';
import { useHistory } from 'react-router-dom';
import { link_config } from '../const';
import Bottom from '../bottom';

import './index.less';

const contentStyle = { color: '#fff', background: '#fff', height: '275px' };

export default function Top(props) {
  const history = useHistory();
  const [currentKey, setCurrentKey] = useState(0);
  const [visible, setVisible] = useState(false);
  const tabChange = (key) => setCurrentKey(key);
  const close = () => setVisible(false);
  const toLink = (params = {}) => {
    const { link_url, type } = params;
    if (+currentKey === 0) {
      if (type === 'modal') {
        setVisible(true);
      } else {
        history.push(link_url);
      }
    } else {
      window.open(link_url, '_blank');
    }
  };
  const helle_config = {
    zh_title: '您好！欢迎来到正大采购平台',
    en_title: 'Hello! Welcome to CP Global Sourcing Platform'
  };
  const company_name = localStorage.getItem('companyName');
  const account = localStorage.getItem('account');

  const toSearch = (index) => {
    const config = {
      0: () => history.push('/basic/home/CP Axtra Public Co.,LTD. (Head office)/2'),
      1: () => window.open('http://online.customs.gov.cn/static/pages/mySearch.html', '_blank'),
      2: () => window.open('https://ciferquery.singlewindow.cn/', '_blank'),
      // 3: () => history.push('/basic/home/北京正大果业有限公司/2'),
      3: () => history.push('/basic/quotation'),
      4: () => history.push('/basic/home/北京正大果业有限公司/2'),
      5: () => history.push('/basic/home/正大商贸/2'),
    };
    config[+index]();
  };

  const carouselRef = useRef();
  const left = () => carouselRef.current.prev();
  const right = () => carouselRef.current.next();
  const items = tabs_list.map((item, index) => {
    return {
      label: item[`${props.language || 'zh_'}title`], key: `${index}`, children: <>
        {
          chunk((item.list || []), 3).map((subItem, subIndex) => {
            return <div className='top-tab-container' key={subIndex}>
              {
                subItem.map((k, i) => {
                  return <div key={i} className='top-tab-container-item' onClick={() => toLink(k)}>
                    <img src={`${STATIC_RESOURCE}/cp_purchase/index/${k.en_title}.png`} alt='' />
                    <div className='top-tab-container-item-text'>{k[`${props.language || 'zh_'}title`]}</div>
                    {/* <div className='top-tab-container-item-text'>{k[`${localStorage.getItem('language') || 'zh_'}title`]}</div> */}
                  </div>;
                })
              }
            </div>;
          })
        }
      </>
    };
  });
  return (
    <>
      <div className='top-container'>
        <div className='top-left'>
          {
            classify_list.slice(0, (classify_list.length - ((props.language || 'zh_') === 'zh_' ? 0 : 0))).map((item, index) => {
              return (
                <div key={index} className='top-left-item'>
                  <div className='top-left-item-container'><img src={`${STATIC_RESOURCE}/cp_purchase/index/${item.en_title}.png`} alt='' /><span className='top-left-item-title'>{item[`${props.language || 'zh_'}title`]}</span></div>
                  <div className='top-left-item-sub-container'>{item.list.map((subItem, subIndex) => <span key={subIndex} onClick={() => {
                    let classify_url_link = '';
                    if (item.level && subItem.level) {
                      classify_url_link += `?item_name=${item.zh_title}&subItem_name=${subItem.zh_title}`;
                    } else {
                      classify_url_link += `?item_name=${subItem.zh_title}`;
                    }
                    history.push(`/basic/home${classify_url_link}`);
                  }}>{subItem[`${props.language || 'zh_'}title`]}</span>)}</div>
                </div>
              );
            })
          }
        </div>
        <div className='top-center'>
          <div className='top-center-carousel'>
            <LeftOutlined className='carousel-btn' onClick={() => left()} />
            <Carousel autoplay ref={carouselRef}>
              <div onClick={() => toSearch(5)}>
                <h3 style={contentStyle}>
                  <img src={`${STATIC_RESOURCE}/cp_purchase/index/global_banner_link.jpg`} alt='' />
                </h3>
              </div>
              <div onClick={() => toSearch(3)}>
                <h3 style={contentStyle}>
                  <img src={`${STATIC_RESOURCE}/cp_purchase/index/big_carousel.png`} alt='' />
                </h3>
              </div>
              <div onClick={() => toSearch(4)}>
                <h3 style={contentStyle}>
                  <img src={`${STATIC_RESOURCE}/cp_purchase/index/banner.jpg`} alt='' />
                </h3>
              </div>
            </Carousel>
            <RightOutlined className='carousel-btn' onClick={() => right()} />
          </div>
          <div className='top-center-img_container'>
            {imgs_list.map((item, index) => {
              return <div key={index} onClick={() => toSearch(index)}><img src={`${STATIC_RESOURCE}/cp_purchase/index/${item.url}.png`} alt='' /></div>;
            })}
          </div>

        </div>
        <div className='top-right'>
          <div className='top-right-top'>
            <div>{company_name}-{account ? account : null}</div>
            <div>{helle_config[`${props.language || 'zh_'}title`]}</div>
          </div>
          <div className='top-right-bottom' >
            <Tabs defaultActiveKey="0" centered items={items} onChange={tabChange} />
            <Typography.Link className='top-right-bottom-text' href={link_config[+currentKey].href} target={link_config[+currentKey].target}>{link_config[+currentKey][`${props.language || 'zh_'}title`]}<RightOutlined /></Typography.Link>
          </div>
        </div>
      </div>
      <Modal open={visible} footer={null} onCancel={close}>
        <Bottom language={props.language || 'zh_'} />
      </Modal>
    </>
  );
}